<div class="export-stream-volume-settings" [resBusySpinner]="isBusy" [message]="isBusyMessage">
    <div class="export-header">
        <label [attr.data-automation-id]="automationId + '-status-label'">
            Status: {{ status }}
        </label>
        <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-help-button'"
            (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>
    <div class="export-settings">
        <div class="export-settings-content" [attr.data-automation-id]="automationId + '-container'">
            <res-export [selectedExportStream]="selectedExportStream" [selectedExportVolume]="selectedExportVolume"
                [optionsDisabled]="true" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
                [automationId]="automationId"></res-export>
        </div>
    </div>
</div>